import View from '../../view.js';

class ClusterVips extends View {
  beforeFilter() {
    if (typeof vipsCounter !== 'undefined') {
      this.counter = vipsCounter;
    }
  }

  _ensureDefaultElement() {
    this._setElement('#main-content');
  }

  get dom() {
    return {
      CONTAINER: '.vips-container',
    };
  }

  get events() {
    return {
      'click #add-vip': 'addVIP',
      'click .remove-vip': 'removeVIP',
      'click .remove-new-vip': 'removeNewVIP',
      'click .undo-vip': 'undoVIP',
    };
  }

  undoVIP(e) {
    var container = $(e.target).parents('.vip-item-container');

    container.find('.vip-destroy').val('false');
    container.find('.vip-item').show();
    container
      .find('.vip-item')
      .find('.missing-required')
      .removeClass('missing-required')
      .prop('required', true);
    container.find('.vip-undo-actions').hide();
  }

  removeNewVIP(e) {
    if (confirm('Are you sure?')) {
      $(e.target).parents('.vip-item').remove();
    }
  }

  removeVIP(e) {
    var container = $(e.target).parents('.vip-item-container');

    if (confirm('Are you sure?')) {
      container.find('.vip-destroy').val('true');
      container.find('.vip-item').hide();
      container
        .find('.vip-item')
        .find('input')
        .addClass('missing-required')
        .removeProp('required');
      container
        .find('.vip-item')
        .find('.field_with_errors')
        .removeClass('field_with_errors');
      container.find('.vip-item').find('small.error').remove();
      container.find('.vip-undo-actions').show();
    }
  }

  addVIP() {
    this.counter++;
    $(this.dom.CONTAINER).append(
      JST['templates/cluster_settings/vips']({
        counter: this.counter,
        ipAddressOptions: ipAddressOptions,
        vipInterfaceOptions: vipInterfaceOptions,
      }),
    );

    $(this.dom.CONTAINER).find('.select2select').select2();
  }
}

module.exports = ClusterVips;
